// src/modules/tribuna-skeleton.js — placeholders de las pantallas de Tribuna.
//
// FASE 4 · DT-BI (parpadeo Tribuna). Mientras llegan los datos del feed
// (getFeedTribuna), las 3 vistas (/tribuna/, /tribuna-cabalas/,
// /tribuna-promesas/) muestran un skeleton estructural en lugar del placeholder
// de texto plano "Cargando la tribuna…" que generaba parpadeo. Cuando el feed
// resuelve, el HTML real reemplaza al skeleton; la clase view-enter ya activa
// el fadeIn natural.
//
// Patrón del Bug #1 (commit 7624aaf, rituales-skeleton.js): HTML puro,
// dimensiones que aproximan el layout final para evitar layout shift, animación
// pulse sutil scope-class `.tribuna-skel`.

const PULSE_STYLE = `<style>
    @keyframes tribunaSkelPulse { 0%, 100% { opacity: .5; } 50% { opacity: .9; } }
    .tribuna-skel { animation: tribunaSkelPulse 1.25s ease-in-out infinite; background: rgba(255,255,255,.045); border: 1px solid rgba(255,255,255,.105); border-radius: 9px; }
</style>`;

// Skeleton de /tribuna/ — header + botón Arengas + muralla 12 lanes + 2 cards
// inferiores + barra de jugadores activos. Replica las medidas del render real.
export const buildTribunaSkeleton = () => `
    ${PULSE_STYLE}
    <div class="view-enter" style="width: 100%; animation: fadeIn 0.4s ease-out forwards;">
        <div style="text-align: center; margin: 0.08rem 0 0.55rem;">
            <h2 style="font-family: var(--font-heading); font-size: 1.65rem; text-transform: uppercase; color: var(--white); margin: 0; line-height: 1;">Tribuna Pública</h2>
            <p style="font-size: 0.82rem; color: var(--text-muted); font-style: italic; margin: 0.18rem 0 0;">Toda Argentina está jugando</p>
        </div>
        <div class="tribuna-skel" style="width: 100%; margin: 0 0 0.52rem; min-height: 56px;"></div>
        <div style="overflow:hidden;margin:0 -1rem 1rem;padding:.05rem 0 .35rem;">
            ${Array.from({ length: 12 }, () => `
                <div style="height: 39px; margin-bottom: 3px; display: flex; gap: .38rem; padding: 0 .5rem;">
                    ${Array.from({ length: 5 }, () => `<div class="tribuna-skel" style="flex: 0 0 150px; height: 36px;"></div>`).join('')}
                </div>
            `).join('')}
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:.5rem;margin:.18rem 0 .55rem;">
            <div class="tribuna-skel" style="min-height:58px;"></div>
            <div class="tribuna-skel" style="min-height:58px;"></div>
        </div>
        <div class="tribuna-skel" style="margin:0 0 1rem;min-height:32px;border-radius:999px;"></div>
    </div>
`;

// Skeleton de /tribuna-cabalas/ — header + CTA + mosaico 3 lanes de cards
// 172px de ancho.
export const buildTribunaCabalasSkeleton = () => `
    ${PULSE_STYLE}
    <div class="view-enter" style="width:100%;animation:fadeIn 0.4s ease-out forwards;">
        <div style="display:flex;align-items:center;gap:.75rem;margin-bottom:.62rem;">
            <div class="tribuna-skel" style="width:54px;min-height:34px;"></div>
            <div style="min-width:0;">
                <h2 style="font-family:var(--font-heading);font-size:1.5rem;text-transform:uppercase;color:var(--white);margin:0;">Cábalas activadas</h2>
                <p style="font-size:.82rem;color:var(--text-muted);margin:.25rem 0 0;line-height:1.28;">Rituales que están corriendo ahora en grupos mundialistas.</p>
            </div>
        </div>
        <div class="tribuna-skel" style="margin:0 0 .82rem;width:100%;min-height:44px;border-radius:999px;"></div>
        <div style="overflow:hidden;margin:.72rem -1rem 1.25rem;padding:.12rem 0 .28rem;display:grid;gap:.46rem;">
            ${Array.from({ length: 3 }, () => `
                <div style="overflow:hidden;padding:0 1rem;">
                    <div style="display:flex;gap:.58rem;">
                        ${Array.from({ length: 5 }, () => `<div class="tribuna-skel" style="flex:0 0 172px;height:150px;border-radius:14px;"></div>`).join('')}
                    </div>
                </div>
            `).join('')}
        </div>
    </div>
`;

// Skeleton de /tribuna-promesas/ — header + CTA + 3 lanes de cards de promesa
// (~282px ancho).
export const buildTribunaPromesasSkeleton = () => `
    ${PULSE_STYLE}
    <div class="view-enter" style="width:100%;animation:fadeIn .4s ease-out forwards;">
        <div style="display:flex;align-items:center;gap:.58rem;margin-bottom:.55rem;">
            <div class="tribuna-skel" style="width:48px;min-height:34px;"></div>
            <div style="min-width:0;">
                <h2 style="font-family:var(--font-heading);font-size:1.22rem;text-transform:uppercase;color:var(--white);margin:0;line-height:1;">Promesas públicas</h2>
                <p style="font-size:.7rem;color:var(--text-muted);margin:.16rem 0 0;line-height:1.16;">Apuestas de honor corriendo ahora en grupos mundialistas.</p>
            </div>
        </div>
        <div class="tribuna-skel" style="margin:0 0 .7rem;width:100%;min-height:42px;border-radius:999px;"></div>
        <div style="overflow:hidden;margin:.62rem -1rem 1rem;padding:.12rem 0 .28rem;display:grid;gap:.48rem;">
            ${Array.from({ length: 3 }, () => `
                <div style="overflow:hidden;padding:0 1rem;">
                    <div style="display:flex;gap:.48rem;">
                        ${Array.from({ length: 4 }, () => `<div class="tribuna-skel" style="flex:0 0 min(78vw, 282px);width:min(78vw, 282px);height:200px;border-radius:13px;"></div>`).join('')}
                    </div>
                </div>
            `).join('')}
        </div>
    </div>
`;
